import { ToastsSubset } from 'store/modules/toasts/index';

export const getLastNotification = (state: ToastsSubset) => state.toasts.lastToast;
